import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import Mispichoshelper from '../../../utils/Mispichoshelper';
import Loading from '../../../components/componentsUI/Loading';
import TransportOrderCard from '../shared/TransportOrderCard';

export default function Completeorder({ showCompleteOrder, compra, refrescarCompra, close }) {
    const [obs, setObs] = useState('');
    const [loading, setLoading] = useState(false);
    const [selectedTransportOrderId, setSelectedTransportOrderId] = useState(null);
    const [transportOrders, setTransportOrders] = useState([]);
    const [loadingOrders, setLoadingOrders] = useState(false);

    useEffect(() => {
        if (compra?.compra_id) {
            setLoadingOrders(true);
            Mispichoshelper.getTransportAndPackingOrdersByPurchaseAndPetshop({ compra_id: compra.compra_id }).then((response) => {
                setLoadingOrders(false);
                if (response && response.payload) {
                    setTransportOrders(response.payload);
                }
            });
        }
        // eslint-disable-next-line
    }, []);

    const sendObs = () => {
        if (obs === '') {
            Modal.error({
                title: 'Importante!',
                content: 'Debes incluir una observacion antes de marcar como entregado',
            });
            return;
        }

        if (transportOrders.length > 0 && !selectedTransportOrderId) {
            Modal.error({
                title: 'Importante!',
                content: 'Debes seleccionar una orden de transporte antes de completar',
            });
            return;
        }

        setLoading(true);
        const payload = {
            compra_id: compra.compra_id,
            observaciones: obs,
            ...(selectedTransportOrderId && { transport_order_id: selectedTransportOrderId }),
        };
        Mispichoshelper.postCompraCompletada(payload).then((response) => {
            setLoading(false);
            Modal.success({
                title: response.payload.title,
                content: response.payload.message,
                okText: 'Entendido',
                onOk: () => window.location.reload()
            });
        });
    };

    return (
        <Modal
            title="Marcar como completada esta compra"
            style={{ minWidth: '50vw' }}
            visible={showCompleteOrder}
            footer={[
                <Button key="back" onClick={() => close('showCompleteOrder', false)}>
                    Volver
                </Button>,
                <Button key="submit" type="primary" loading={loading} disabled={loading} onClick={() => sendObs()}>
                    Si, completar compra
                </Button>,
            ]}
        >
            {loadingOrders && (
                <div style={{ marginBottom: 16 }}>
                    <Loading />
                </div>
            )}
            {!loadingOrders && transportOrders.length > 0 && (
                <div style={{ marginBottom: 16 }}>
                    <p style={{ fontWeight: 600, marginBottom: 8 }}>Seleccionar orden de transporte:</p>
                    <p style={{ fontSize: 12, color: '#595959', marginBottom: 8 }}>
                        Esta compra tiene asociada una o más órdenes de transporte. Por favor selecciona cuál de ellas corresponde a esta entrega.
                    </p>
                    <div style={{ fontSize: 12, color: '#595959', marginBottom: 16, display: 'flex', flexDirection: 'column', gap: 4 }}>
                        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <span style={{ display: 'inline-block', width: 12, height: 12, borderRadius: 3, backgroundColor: '#f0f5ff', border: '1.5px solid #91caff', flexShrink: 0 }} />
                            Orden activa
                        </span>
                        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <span style={{ display: 'inline-block', width: 12, height: 12, borderRadius: 3, backgroundColor: 'transparent', border: '1.5px solid #003eb3', flexShrink: 0 }} />
                            Orden seleccionada
                        </span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        {transportOrders.map((item) => (
                            <TransportOrderCard
                                key={item.transport_order.id}
                                item={item}
                                isSelected={selectedTransportOrderId === item.transport_order.id}
                                onClick={() => setSelectedTransportOrderId(item.transport_order.id)}
                            />
                        ))}
                    </div>
                </div>
            )}
            <TextArea
                className='campoTextarea'
                placeholder="Detalles del inconveniente"
                autosize={{ minRows: 6, maxRows: 6 }}
                value={obs}
                onChange={(evt) => setObs(evt.target.value)}
            />
        </Modal>
    );
}
